/**
 * A mapping of application routes to their corresponding i18n translation module names.
 * Each route is mapped to an array of module names that should be loaded for that route.
 * 
 * @type {Record<string, string[]>}
 * @property {string[]} [key] - The application route path
 * @property {string[]} [value] - Array of module names to load for the route
 *                                Always includes 'common' as the base module
 *                                followed by route-specific module names
 */
export const routeModuleMap: Record<string, string[]> = {
  // Auth routes
  '/login': ['common', 'auth', 'profile'],
  '/signup': ['common', 'auth', 'profile'],
  '/sent-email': ['common', 'auth', 'profile'],
  '/activate': ['common', 'auth', 'profile'],
  '/resetpassword': ['common', 'auth', 'profile'],
  '/success': ['common', 'auth', 'profile'],
  '/activate-failed': ['common', 'auth', 'profile'],
  '/forgot-password': ['common', 'auth', 'profile'],
  '/verify-key': ['common', 'auth', 'mfa', 'profile'],
  '/signup-email-sent': ['common', 'auth', 'profile'],
  '/redirect': ['common', 'auth', 'profile'],
  
  // Main app routes
  '/home': ['common', 'organization', 'profile'],
  '/profile': ['common', 'profile', 'mfa'],
  '/identity-management': ['common', 'iam', 'profile'],
  '/chat': ['common', 'chat', 'profile'],
  '/project': ['common', 'profile'],
  '/organization-management': ['common', 'organization', 'iam', 'profile'],
  '/media-library': ['common', 'file-manager', 'profile'],
  '/document-management': ['common', 'document-manager', 'profile'],
  
  // Subscription & Payment routes
  '/subscription': ['common', 'subscription', 'profile'],
  '/checkout': ['common', 'subscription', 'profile'],
  '/payment-success': ['common', 'subscription', 'profile'],
  '/payment-cancelled': ['common', 'subscription', 'profile'],
  
  // Other routes
  '/promotion': ['common', 'auth', 'profile'],
  '/pdf-viewer': ['common', 'file-manager', 'profile'],
};
